import axios from 'axios';

export async function fetchPayslipRow(apiBase, { month, year, cutoffId } = {}) {
  const requestPayslip = async () => axios.get(`${apiBase}/api/payslip/me`, {
    withCredentials: true,
    params: { month, year, cutoff_id: cutoffId || undefined, _ts: Date.now() },
  });

  try {
    const response = await requestPayslip();
    return response?.data?.payslip
      || (Array.isArray(response?.data?.rows) && response.data.rows.length > 0 ? response.data.rows[0] : null)
      || null;
  } catch (error) {
    if (error?.response?.status === 401) {
      await axios.get(`${apiBase}/api/me`, { withCredentials: true });
      const response = await requestPayslip();
      return response?.data?.payslip
        || (Array.isArray(response?.data?.rows) && response.data.rows.length > 0 ? response.data.rows[0] : null)
        || null;
    }
    throw error;
  }
}
